// extracted by mini-css-extract-plugin
export default {"guestsMessage":"index-module__d_HS0","switch":"index-module__uQHa3","formContainer":"index-module__94Boo","switchItem":"index-module__SGbD6"};